import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/#hakkımızda' },
    { name: 'Projeler', path: '/#projeler' },
    { name: 'Takım', path: '/takim' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  const handleNavClick = (path: string) => {
    setIsMobileMenuOpen(false);
    
    if (path.includes('#')) {
      const [route, hash] = path.split('#');
      if (route === '' || route === '/') {
        if (location.pathname !== '/') {
          window.location.href = path;
        } else {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-4 group cursor-pointer">
          <img
            src="https://static.readdy.ai/image/d01eec00e4772b31ebec3f16d57f9686/a135775721950a9d58bee29176af8952.jpeg"
            alt="TETRA Logo"
            className="h-12 w-12 object-contain group-hover:scale-110 transition-transform duration-300"
          />
          <span className="text-2xl font-bold group-hover:text-[#00d9ff] transition-colors duration-300">
            TETRA
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link, index) => (
            link.path.includes('#') ? (
              <a
                key={index}
                href={link.path}
                onClick={(e) => {
                  if (location.pathname === '/') {
                    e.preventDefault();
                    handleNavClick(link.path);
                  }
                }}
                className="text-base font-medium text-white/80 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer relative group"
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d9ff] group-hover:w-full transition-all duration-300" />
              </a>
            ) : (
              <Link
                key={index}
                to={link.path}
                className="text-base font-medium text-white/80 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer relative group"
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d9ff] group-hover:w-full transition-all duration-300" />
              </Link>
            )
          ))}
        </div>

        {/* CTA Button */}
        <Link
          to="/iletisim"
          className="hidden md:block px-8 py-3 bg-[#00d9ff] text-black font-bold rounded-full hover:bg-[#00b8d4] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          Bize Ulaşın
        </Link>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-white/10">
          <div className="px-8 py-6 space-y-4">
            {navLinks.map((link, index) => (
              link.path.includes('#') ? (
                <a
                  key={index}
                  href={link.path}
                  onClick={(e) => {
                    if (location.pathname === '/') {
                      e.preventDefault();
                    }
                    handleNavClick(link.path);
                  }}
                  className="block text-lg font-medium text-white/80 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={index}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block text-lg font-medium text-white/80 hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer"
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link
              to="/iletisim"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full px-8 py-3 bg-[#00d9ff] text-black font-bold rounded-full text-center hover:bg-[#00b8d4] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Bize Ulaşın
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
